import { IonApp, setupIonicReact } from '@ionic/react';
/* Core CSS required for Ionic components to work properly */
import '@ionic/react/css/core.css';
import Router from './router/Router';
import './global.css';
import SlugGuard from './router/guards/SlugGuard';

setupIonicReact({
  mode: 'ios',
});

const MobileApp = () => {
  return (
    <IonApp>
      <SlugGuard>
        <Router />
      </SlugGuard>
    </IonApp>
  );
};

export default MobileApp;
